import {
  ajaxPost,
  parceAjaxErrorResponse,
  toggleBetweenElements,
} from "./utils";
import {ErrorSwal} from "../app";
import {bsModal} from "./plugins";

$(document).on("click", ".searchPersonInlineBtn", function (e) {
  e.preventDefault();
  const searchButton = $(this);
  const searchPersonForm = searchButton.closest(".searchPersonInlineForm");
  const searchPersonResult = searchPersonForm.next();
  const personType = searchPersonForm.find(".personType").val();
  const identityNumberInput = searchPersonForm.find(".identificationNumber");
  if (
    identityNumberInput[0].checkValidity() === false ||
    identityNumberInput.val() === ""
  ) {
    identityNumberInput[0].reportValidity();
    return;
  }
  const identityNumber = identityNumberInput.val();
  const personIdInput = searchPersonResult.find(".personId");
  const personContentTypeIdInput = searchPersonResult.find(".personContentTypeId");
  const personName = searchPersonResult.find(".personName");
  const modal = bsModal("full", {
    title: "Vasitəçi şəxsin seçilməsi",
    modalId: "selectPersonModal",
    backdrop: "none",
    keyboard: true,
  });
  let url, modalPostData;
  if (personType === "L") {
    url = "/crm/legal-persons/ajax/";
    modalPostData = {
      action: "search_modal",
      tin: identityNumber,
    };
  } else {
    url = "/crm/physical-persons/ajax/";
    modalPostData = {
      action: "search_modal",
      search: identityNumber,
    };
  }

  ajaxPost(url, modalPostData)
    .then((response) => {
      $(modal).modal("content", response["html"]);
    })
    .catch((errors) => {
      ErrorSwal.fire({
        html: parceAjaxErrorResponse(errors),
      }).then(() => {
        $(modal).modal("hide");
      });
    });

  $(modal).on("callback", (e, modalData) => {
    personIdInput.val(modalData.data.id);
    personContentTypeIdInput.val(modalData.data.content_type_id);
    personName.val(modalData.data.full_name);
    toggleBetweenElements(searchPersonForm, searchPersonResult, 200);
  });
});

$(document).on("click", ".selectPersonInlineBtn", function (e) {
  const searchButton = $(this);
  const searchPersonResult = searchButton.closest(".searchPersonInlineResult");
  const searchPersonForm = searchPersonResult.prev();

  searchPersonResult.find(".personId").val("");
  searchPersonResult.find(".personContentTypeId").val("");
  searchPersonResult.find(".personName").val("");

  toggleBetweenElements(searchPersonResult, searchPersonForm, 200);
});
